import { useEffect, useState } from "react";
import { UserPlus, X } from "lucide-react";
import { useAuthStore } from "@/stores/auth-store";
import { useAppStore } from "@/stores/app-store";
import { useUIStore } from "@/stores/ui-store";
import { useOrgJoinStore } from "@/stores/org-join-store";

export function OrgJoinBanner() {
    const user = useAuthStore((s) => s.user);
    const extensionName = useAppStore((s) => s.extensionName);
    const receivedRequests = useOrgJoinStore((s) => s.receivedRequests);
    const refreshJoinRequests = useOrgJoinStore((s) => s.refreshJoinRequests);
    const settingsOpen = useUIStore((s) => s.settingsOpen);
    const openSettings = useUIStore((s) => s.openSettings);
    const setActiveSettingsTab = useUIStore((s) => s.setActiveSettingsTab);
    const [hidden, setHidden] = useState(false);

    useEffect(() => {
        if (!user?.email || !extensionName) return;
        refreshJoinRequests();
        const onFocus = () => refreshJoinRequests();
        window.addEventListener("focus", onFocus);
        return () => window.removeEventListener("focus", onFocus);
    }, [user?.email, extensionName, refreshJoinRequests]);

    const count = Object.values(receivedRequests).filter(
        (r) => (r.status || 'pending').toLowerCase() === "pending"
    ).length;

    if (hidden || settingsOpen || count === 0) return null;

    const openRequests = () => {
        setActiveSettingsTab("app-users");
        openSettings();
    };

    return (
        <div className="flex items-center justify-center gap-2 bg-gradient-to-r from-blue-600 via-blue-500 to-blue-600 text-white text-xs font-medium py-1.5 px-3 shrink-0 z-50">
            <UserPlus className="h-3.5 w-3.5 shrink-0" />
            <span>
                {count === 1 ? "1 person wants" : `${count} people want`} to join your organization
            </span>
            <button
                onClick={openRequests}
                className="ml-1 rounded bg-white/20 px-2 py-0.5 hover:bg-white/30 transition-colors"
            >
                Review
            </button>
            <button onClick={() => setHidden(true)} className="rounded p-0.5 hover:bg-white/20">
                <X className="h-3 w-3" />
            </button>
        </div>
    )

}